// extracted by mini-css-extract-plugin
export default {"container":"mRGWLRevYYRmmah5QhT9","heading":"gnlOi7NecQATRCKG4srm","subtext":"H_O8hLPGJyijM45vPxjM","consentCheckboxes":"p1LC5MvkIGKS9TizmKCn","checkboxBlock":"LxT8zoNc6i0PzhSWtg3q"};